export default __webpack_public_path__ + "static/yogurt-fruit-bistro-1b84cc37ccf4afce8cb1aa5b6a2f02c1.jpg";